import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppinfoService, ReportType } from 'app/services/appinfo.service';
import { FilterOption, MainDataService } from 'app/services/main-data.service';
import { AppInterlayerReport, InterlayerReportService } from 'app/services/interlayer-report.service';
import { TooltipHelpService } from 'app/services/tooltip-help.service';
import { Subscription } from 'rxjs';
import { CommonFunctionService } from 'app/services/common-function.service';

@Component({
  selector: 'app-tab-report-filters',
  templateUrl: './tab-report-filters.component.html',
  styleUrls: ['../../content-layers/qc-filters-my-layers/qc-filters-my-layers.component.css', './tab-report-filters.component.css']
})
export class TabReportFiltersComponent implements OnInit, OnDestroy {
	
	filterOptions: FilterOption[] = [];

	selectedReportType: ReportType;
	reportTypes: ReportType[];

	selectedReport: AppInterlayerReport;

	isGenerating = false;

	private mouseoverCodeTimeout;

	private filterOptionsSub: Subscription;
	private selectedReportSub: Subscription;
	private qrFinishSub: Subscription;

	constructor(
		private appinfoService: AppinfoService,
		private commonService: CommonFunctionService,
		private reportService: InterlayerReportService,
		private mainDataService: MainDataService,
		private tooltipHelpService: TooltipHelpService
	) { }

	async generate() {
		this.isGenerating = true;
		try {
			await this.reportService.qrInterlayer(this.selectedReportType.value, this.mainDataService.modelBS.getValue());
		} catch (err) {
			console.log(err)
		}
		this.isGenerating = false;
	}

	async onSelectReportType() {
		const spinnerId = this.commonService.getRandomId();
		this.commonService.setLoadingSpinner(true, spinnerId);
		try {
			const reportType = this.selectedReportType.value === 'ALL' ? null : this.selectedReportType.value;
			const reports = await this.reportService.getQrReportTabs(reportType);
			//
			this.reportService.reportListBS.next({
				reportType: this.selectedReportType.value,
				list: reports
			});
		} catch (err) {
			console.log(err);
		}
		this.commonService.setLoadingSpinner(false, spinnerId);
	}
	toggleFilterOption(option: FilterOption) {
		this.reportService.reportFilterInfoBS.next({
			filterOptions: this.filterOptions,
			source: 'filterTabToggle'
		});
		this.reportService.requestData.next();
	}
	onMouseoverCode(option: FilterOption) {
		this.mouseoverCodeTimeout = setTimeout(() => {
			const codes = [option.value];
			this.tooltipHelpService.lastTooltipsBS.next({
				codes: codes
			});
		}, this.tooltipHelpService.delayTime);
	}
	onMouseoutCode() {
		if (this.mouseoverCodeTimeout) {
			clearTimeout(this.mouseoverCodeTimeout);
		}
	}

	async ngOnInit() {
		this.reportTypes = this.appinfoService.reportTypeList;
		this.selectedReportType = this.reportTypes[0];
		await this.onSelectReportType();
		this.filterOptionsSub = this.reportService.reportFilterInfoBS.subscribe((data) => {
			if (data.source !== 'filterTabToggle') {
				this.filterOptions = data.filterOptions;
			}
		});
		this.selectedReportSub = this.reportService.selectedReportBS.subscribe(data => {
			this.selectedReport = data;
		});
		// Update report list on qc finishing
		this.qrFinishSub = this.reportService.onQrFinish.subscribe(async () => {
			const spinnerId = this.commonService.getRandomId();
			this.commonService.setLoadingSpinner(true, spinnerId);
			try {
				await this.onSelectReportType();
			} catch (err) {
				console.log(err);
			}
			this.commonService.setLoadingSpinner(false, spinnerId);
		});
	}
	ngOnDestroy(): void {
		this.filterOptionsSub.unsubscribe();
		this.selectedReportSub.unsubscribe();
		this.qrFinishSub.unsubscribe();
	}

}
